import Decimal from 'decimal.js'

export const maxBigInt = (...values: bigint[]): bigint => {
  return values.reduce((max, current) => (current > max ? current : max))
}

export const minBigInt = (...values: bigint[]): bigint => {
  return values.reduce((min, current) => (current < min ? current : min))
}

export const addMultiplier = (
  base: bigint,
  multiplier: number,
  roundMethod: 'floor' | 'ceil' = 'floor'
) => {
  let result = Decimal(base).mul(multiplier)
  result = roundMethod === 'floor' ? result.floor() : result.ceil()

  return BigInt(result.toFixed())
}
